import counter from '@/api/inventory/counter-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  foodCourts: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_FOOD_COURT(state, foodCourts) {
    state.foodCourts = foodCourts
  },
  SET_EDIT_DATA(state, edit_data) {
    state.edit_data = edit_data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return counter.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return counter.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await counter.find(id)
      context.commit('SET_EDIT_DATA', response.data)
      return Promise.resolve(response.data)
    }
  },
  update(context, data) {
    return counter.update(data)
  },

  destroy(context, id) {
    return counter.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.foodCourts.length > 0) {
      let response = await counter.getFoodCourt()
      context.commit('RECEIVE_FOOD_COURT', response)
    }
  }
}
